import { render, staticRenderFns } from "./MainHolderInfo.vue?vue&type=template&id=5e8c1d03&scoped=true&"
import script from "./MainHolderInfo.vue?vue&type=script&lang=js&"
export * from "./MainHolderInfo.vue?vue&type=script&lang=js&"
import style0 from "./MainHolderInfo.vue?vue&type=style&index=0&id=5e8c1d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c1d03",
  null
  
)

export default component.exports